import React, {PropTypes} from 'react';
import classNames from 'classnames';

const BackButton = ({children, className, onClick}) => {
  const cssClass = classNames({
    'tes-btn': true,
  }, className);

  return (
    <button type="button" className={cssClass} onClick={onClick}>
      <span className="icon-text-container">
        <i className="icon-chevron-left icon-white" />
        {children}
      </span>
    </button>
  );
};

BackButton.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default BackButton;
